import { render, staticRenderFns } from "./form3.vue?vue&type=template&id=0c08ff88&scoped=true&"
import script from "./form3.vue?vue&type=script&lang=js&"
export * from "./form3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c08ff88",
  null
  
)

export default component.exports